export const restrictToNumbers = (evt) => {
	let charCode = evt.which ? evt.which : evt.keyCode;
	if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
		evt.preventDefault();
	}
};
export const expertiseFunction = (vueObj) => {
	vueObj.aoe = true;
	vueObj.$forceUpdate();
};
export const tagValidatoraoe = (tag, vueObj) => {
	let skills = vueObj.aoeoptiontags.map((s) => s.toLowerCase());
	return !skills.includes(tag.toLowerCase());
};
export const hideexpertiseoptions = (vueObj) => {
	vueObj.aoe = false;
};
export const skillFunction = (vueObj) => {
	vueObj.skilltag = !vueObj.skilltag;
	vueObj.$forceUpdate();
};
export const hideskillOptions = (vueObj) => {
	vueObj.skilltag = false;
};
export const tagValidator = (tag, vueObj) => {
	let skills = vueObj.skilloptionstag.map((s) => s.toLowerCase());
	return !skills.includes(tag.toLowerCase());
};

export const checkAddResponse = (res, vueObj) => {
	if (res.status == 200) {
		vueObj.LoaderStatus = false;
		vueObj.$router.push({
			name: "EvaluatorList",
		});
		vueObj.$emit("onAddEvaluator");
		vueObj.$nextTick(() => {
			vueObj.successToast("Evaluator added successfully!");
		});
		vueObj.clearevaldata();
	} else if (res.status == 409) {
		vueObj.LoaderStatus = false;
		let errorMessage = res.data.data.Detail;
		vueObj.errorToast(`${errorMessage}`);
	} else {
		vueObj.LoaderStatus = false;
		vueObj.errorToast("Something went wrong!");
	}
};

export const checkUpdateResponse = (res, vueObj) => {
	if (res.status == 200) {
		vueObj.LoaderStatus = false;
		vueObj.$router.push({
			name: "EvaluatorList",
		});
		vueObj.$emit("onEditEvaluator");
		vueObj.$nextTick(() => {
			vueObj.successToast("Evaluator updated successfully");
		});
	} else {
		vueObj.LoaderStatus = false;
		vueObj.errorToast("Something went wrong!");
	}
};

export const validData = (vueObj) => {
	return !vueObj.$v.$invalid && vueObj.phoneValid;
};
